// src/pages/HomePage.jsx

import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";

import about1Desktop from "../assets/images/about-1-desktop.webp";
import about1Mobile from "../assets/images/about-1-mobile.webp";

import about2Desktop from "../assets/images/about-2-desktop.webp";
import about2Mobile from "../assets/images/about-2-mobile.webp";

import about3Desktop from "../assets/images/about-3-desktop.webp";
import about3Mobile from "../assets/images/about-3-mobile.webp";

import emric from "../assets/images/emric.png";
import emricPronunciation from "../assets/audio/emric.mp3";

import allProducts from "../assets/data/processedProducts";
import ProductCard from "../components/ProductCard";
import imageMap from "../assets/data/imageMap";

const slides = [
  {
    text: "Best Quality",
    desktop: about1Desktop,
    mobile: about1Mobile,
  },
  {
    text: "Best Design",
    desktop: about2Desktop,
    mobile: about2Mobile,
  },
  {
    text: "Best Prices",
    desktop: about3Desktop,
    mobile: about3Mobile,
  },
];

// Featured Products
const featuredProductIDs = [16, 107, 1];

const HomePage = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3500,
    slidesToShow: 1,
    slidesToScroll: 1,
    cssEase: "ease-in-out",
    pauseOnHover: false,
    arrows: false,
    adaptiveHeight: false,
  };

  const featuredProducts = allProducts.filter((p) =>
    featuredProductIDs.includes(p.ID)
  );

  return (
    <div>
      {/* Hero Slider */}
      <section className="relative">
        <Slider {...settings}>
          {slides.map((slide, index) => (
            <div key={index}>
              <div className="relative h-screen overflow-hidden">
                
                {/* Desktop Image */}
                <img
                  src={slide.desktop}
                  alt={slide.text}
                  className="hidden md:block w-full h-full object-cover"
                />

                {/* Mobile Image */}
                <img
                  src={slide.mobile}
                  alt={slide.text}
                  className="block md:hidden w-full h-full object-cover"
                />

                {/* Overlay */}
                <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                  <p className="text-white text-3xl md:text-5xl font-bold text-center px-4 drop-shadow-lg">
                    {slide.text}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </section>

      {/* EMRIC Brand Section */}
      <section className="bg-gray-100 py-16 px-4 text-center">
        <div className="max-w-4xl mx-auto space-y-6">
          <p className="text-sm text-black uppercase tracking-wide">
            Our Signature Brand
          </p>

          <img
            src={emric}
            alt="EMRIC Logo"
            className="mx-auto w-full max-w-xl h-auto"
          />

          <div className="text-center space-y-2">
            <h2 className="text-5xl font-bold text-gray-800 tracking-wide">
              EMRIC
            </h2>

            <div className="text-base italic text-gray-500 flex items-center justify-center gap-2">
              /ˈɛm.rɪk/
              <button
                onClick={() => new Audio(emricPronunciation).play()}
                className="text-gray-400 hover:text-gray-700"
                title="Play pronunciation"
              >
                🔊
              </button>
            </div>

            <p className="text-lg text-gray-700 mt-2">
              <span className="font-medium">noun</span>
              <br />
              A name of Germanic origin meaning <em>"ruler"</em> or{" "}
              <em>"powerful leader."</em>
            </p>
          </div>
        </div>
      </section>

      {/* Featured Products */}
      <section className="py-12 px-4">
        <h2 className="text-2xl font-semibold text-center mb-8 text-gray-800">
          Featured Products
        </h2>

        <div className="grid gap-6 grid-cols-1 md:grid-cols-3 max-w-6xl mx-auto">
          {featuredProducts.map((product) => (
            <ProductCard
              key={product.ID}
              product={product}
              imageMap={imageMap}
            />
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/products/taps"
            className="inline-block mt-4 bg-[#32587a] text-white px-6 py-2 rounded hover:bg-[#26415c] transition"
          >
            View All Products
          </Link>
        </div>
      </section>
    </div>
  );
};

export default HomePage;